import React, { useMemo } from 'react';
import { useEnabledGroupTypes } from './hooks/useEnabledGroupTypes';
import { useStartEndSettings } from './hooks/useStartEndSettings';
import { StartEndSettingsPage } from './StartEndSettingsPage';
import { StartEndSettingsPageSkeleton } from './StartEndSettingsPageSkeleton';
export const StartEndSettingsLanding: React.FC = () => {
  const { data, loading } = useEnabledGroupTypes();
  const {
    data: settingsData,
    loading: settingsLoading
  } = useStartEndSettings();
  const enabledGroupTypes = useMemo(
    () => data?.enabledGroupTypes?.items || [],
    [data]
  );

  const settings = useMemo(
    () => settingsData?.getStartEndSettings?.settings || [],
    [settingsData]
  );

  if (loading || settingsLoading) {
    return <StartEndSettingsPageSkeleton />;
  }

  return (
    <div data-testid="StartEndSetting">
      <StartEndSettingsPage
        enabledGroupTypes={enabledGroupTypes}
        settings={settings}
      />
    </div>
  );
};
